export default __webpack_public_path__ + "static/media/O-085.e27dcef7.png";